/**
 * События набора libre.nodes. created несёт обёрнутый ключ узла и шифротексты места и данных;
 * moved — только место, changed — только данные: они сворачиваются порознь
 */
export enum EnumLibreEvent {
  CREATED = 'created',
  MOVED = 'moved',
  CHANGED = 'changed',
  REMOVED = 'removed',
  RESTORED = 'restored',
}
